import { Transaction } from '@solana/web3.js';

export function deduplicateTransactionSigners(
  transaction: Transaction,
  mintAddress?: string,
): void {
  const seenSigners = new Set<string>();

  transaction.instructions.forEach((instruction) => {
    instruction.keys.forEach((key) => {
      const pubkeyStr = key.pubkey.toBase58();
      if (key.isSigner && !pubkeyStr.startsWith('1')) {
        if (seenSigners.has(pubkeyStr) && pubkeyStr !== mintAddress) {
          key.isSigner = false;
        } else {
          seenSigners.add(pubkeyStr);
        }
      }
    });
  });
}
